import {combineReducers} from 'redux';
import Inbox from 'routes/Home/Requests/Box/Inbox/Module';
import Outbox from 'routes/Home/Requests/Box/Outbox/Module';
import Draft from 'routes/Home/Requests/Box/Draft/Module';

const reducers = combineReducers({
  Inbox,
  Outbox,
  Draft,
});

export default reducers;
